<template>
  <section class="lms-container">
    <div class="content">
      <div class="breadcrumb" style="border: none !important;"></div>
      <div class="annotation-page" style="display: block;">
        <div class="title-annotation-content">
          <button @click="close()" class="back-to-anottations">voltar</button>
          <h5
            id="annotation-description"
            style="font-size: 14px;"
          >{{lessonName}}</h5>
          <!-- <a href="#" class="export-video-anottation" target="_blank" style="font-size: 14px;">
            <span class="icon icon-upload" title="exportar anotação do vídeo"></span>
          </a> -->
        </div>

        <!-- <div id="editor-status" class="success">Salvo</div> -->
        <!-- <div id="toolbar-container">
        </div>-->
        <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
          <div class="menubar">
            <button
              class="menubar__button"
              :class="{ 'is-active': isActive.editorHighlight() }"
              @click="commands.editorHighlight()"
            >
              <i class="material-icons">highlight</i>
            </button>
            <button
              class="menubar__button"
              :class="{ 'is-active': isActive.bold() }"
              @click="commands.bold"
            >
              <i style="color:black;" class="material-icons">format_bold</i>
            </button>

            <button
              class="menubar__button"
              :class="{ 'is-active': isActive.italic() }"
              @click="commands.italic"
            >
              <i style="color:black;" class="material-icons">format_italic</i>
            </button>

            <button
              class="menubar__button"
              :class="{ 'is-active': isActive.strike() }"
              @click="commands.strike"
            >
              <i class="material-icons">format_strikethrough</i>
            </button>

            <button
              class="menubar__button"
              :class="{ 'is-active': isActive.underline() }"
              @click="commands.underline"
            >
              <i class="material-icons">format_underlined</i>
            </button>

            <button
              class="menubar__button"
              :class="{ 'is-active': isActive.bullet_list() }"
              @click="commands.bullet_list"
            >
              <i class="material-icons">insert_link</i>
            </button>
            <button
              class="menubar__button"
              :class="{ 'is-active': isActive.heading({ level: 1 }) }"
              @click="commands.heading({ level: 1 })"
            >H1</button>

            <button
              class="menubar__button"
              :class="{ 'is-active': isActive.heading({ level: 2 }) }"
              @click="commands.heading({ level: 2 })"
            >H2</button>

            <button
              class="menubar__button"
              :class="{ 'is-active': isActive.heading({ level: 3 }) }"
              @click="commands.heading({ level: 3 })"
            >H3</button>

            <button
              class="menubar__button"
              :class="{ 'is-active': isActive.ordered_list() }"
              @click="commands.ordered_list"
            >
              <i class="material-icons">format_list_bulleted</i>
            </button>

            <button
              class="menubar__button"
              :class="{ 'is-active': isActive.blockquote() }"
              @click="commands.blockquote"
            >
              <i class="material-icons">format_quote</i>
            </button>

            <button class="menubar__button" @click="commands.undo">
              <i class="material-icons">undo</i>
            </button>

            <button class="menubar__button" @click="commands.redo">
              <i class="material-icons">redo</i>
            </button>
          </div>
        </editor-menu-bar>
        <editor-content :editor="editor" />
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.custom-grid-inactives {
  @media (min-width: 1024px) {
    grid-template-columns: 1fr 1fr 1fr 1fr !important;
  }
}
</style>

<script>
import axios from "axios";
import { Editor, EditorContent, EditorMenuBar } from "tiptap";
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  HorizontalRule,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History
} from "tiptap-extensions";
import EditorHighlight from "../Lesson/EditorHighlight";

export default {
  props: {
    lessonName: {
      type: String,
      required: true
    },
    annotationJson: {
      type: Object,
      required: true
    },
    videoId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      needSave: false,
      timeCount: new Date(),
      editor: null
    };
  },
  components: {
    EditorContent,
    EditorMenuBar
  },
  methods: {
    close() {
      this.$emit("close");
    },
    saveAnnotation() {
      var endTime = new Date();
      var timeDiff = endTime - this.timeCount; //in ms
      timeDiff /= 1000;
      var seconds = Math.round(timeDiff);

      if (seconds > 1) {
        this.needSave = false;
        this.timeCount = new Date();

        const path = this.$global.endpoint + "/video/annotation/save";
        axios
          .post(path, {
            videoId: this.videoId,
            content: this.annotationJson
          })
          .then(res => {})
          .catch(error => {
            console.error(error);
          });
      } else {
        this.needSave = true;
      }
    }
  },
  created() {
    this.editor = new Editor({
      extensions: [
        new Blockquote(),
        new BulletList(),
        new CodeBlock(),
        new HardBreak(),
        new Heading({ levels: [1, 2, 3] }),
        new HorizontalRule(),
        new ListItem(),
        new OrderedList(),
        new TodoItem(),
        new TodoList(),
        new Link(),
        new Bold(),
        new Code(),
        new Italic(),
        new Strike(),
        new Underline(),
        new History(),
        new EditorHighlight()
      ],
      content: this.annotationJson,
      onUpdate: ({ getHTML, getJSON }) => {
        this.annotationJson = getJSON();
        this.saveAnnotation();
      }
    });
  }
};
</script>
